import { render, staticRenderFns } from "./ProductSurfaces.vue?vue&type=template&id=23c1eefb&"
import script from "./ProductSurfaces.vue?vue&type=script&lang=js&"
export * from "./ProductSurfaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports